<template>
  <v-row class="mt-2" justify="center" no-gutters>
    <v-col cols="12" class="px-2 px-md-4">
      <div class="dashboard-iframe-wrapper">
        <iframe
          class="dashboard-iframe"
          title="BI_INDGER_BRASIL"
          src="https://app.powerbi.com/view?r=eyJrIjoiMmYzY2E0NDMtMGFiYS00NTdiLThhMTItYzY0ODdkZjhmNmFmIiwidCI6IjZhMjIyODZlLTkyNmItNGJiNi1hY2M0LTA1NDVhNTMzZWFmZiJ9"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "DashboardPainelBrasil",
    mounted() {
      this.$toast.info(
        "<b>Dica:</b> ajuste o zoom no canto inferior direito do PowerBI ou use tela cheia para melhor visualização.",
        "",
        {
          position: "topRight",
          timeout: 15000,
        },
      );
    },
  };
</script>

<style scoped>
  .dashboard-iframe-wrapper {
    width: 100%;
    height: calc(100vh - 150px);
    min-height: 560px;
  }

  .dashboard-iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }

  @media (max-width: 960px) {
    .dashboard-iframe-wrapper {
      height: calc(100vh - 110px);
      min-height: 480px;
    }
  }
</style>
